module.exports = __webpack_public_path__ + "media/components/country-flag/static/gd-67cf83598998b9e3e9776be75a7597e9.svg";